import axios, { AxiosRequestConfig } from 'axios';
import { STORAGE_KEYS } from 'utils/constants';

const BASE_API_URL = process.env.REACT_APP_API_URL;
const BASE_API_KEY = process.env.REACT_APP_API_KEY;

interface ApiServiceOptions extends AxiosRequestConfig {
  useToken?: boolean;
  isInternal?: boolean;
  version?: string;
}

const getToken = () => {
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
  return token;
};

const makeRequest = <T>(urlPath: string, options: ApiServiceOptions) => {
  const { useToken = true, isInternal, baseURL, version = '', ...otherOptions } = options;
  const localStorageStore = sessionStorage.getItem(STORAGE_KEYS.ACTIVE_STORE);
  const storeId = localStorageStore ? JSON.parse(localStorageStore ?? '') : '';

  const headers = options?.headers ?? {};
  if (isInternal) headers['x-api-key'] = BASE_API_KEY;
  if (useToken) headers['Authorization'] = 'Bearer ' + getToken();
  if (storeId?.id) headers['x-store-id'] = storeId.id;

  const fullUrl = `${baseURL ?? BASE_API_URL}${version ? version + '/' : ''}${urlPath}`;
  return axios.request<T>({ ...otherOptions, url: fullUrl, headers });
};

export const apiService = {
  get: <T = any>(urlPath: string, options: ApiServiceOptions = {}) =>
    makeRequest<T>(urlPath, { method: 'get', ...options }),
  patch: <T = any>(urlPath: string, options?: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'patch', ...options }),
  post: <T = any>(urlPath: string, options?: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'post', ...options }),
  put: <T = any>(urlPath: string, options: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'put', ...options }),
  delete: <T = any>(urlPath: string) => makeRequest<T>(urlPath, { method: 'delete' })
};
